import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'file-dashboard-status',
  templateUrl: './file-dashboard-status.component.html',
  styleUrls: ['./file-dashboard-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileDashboardStatusComponent implements OnInit {
  @Input() dashboard_status: any;
  @Input() customFont = false;
  constructor() {}

  ngOnInit(): void {}
}
